import { NavLink, Outlet } from 'react-router';

import { useSessao } from '@/features/autenticacao/useSessao';

import estilos from './LayoutDeCadastros.module.css';

/**
 * Área de cadastros: áreas, clientes e usuários.
 *
 * POR QUE UMA ÁREA, E NÃO TRÊS LINKS NO TOPO
 *
 * Os três eram links de primeiro nível ao lado dos painéis, disputando espaço com o
 * trabalho do dia. Cadastro é operação ocasional de administrador: agrupar tira três
 * itens da navegação principal e deixa claro que os três são o mesmo assunto.
 *
 * CADASTRO É DE ADMIN. As três permissões são exclusivas dele — `cliente.gerenciar` era a
 * única fora, concedida ao Gestor de CS, e saiu com a migration `CadastroSomenteAdmin`.
 *
 * ESCONDER ABA NÃO É PROTEÇÃO. O servidor recusa com 403 quem não tem a permissão, e quem
 * digitar /cadastros/areas vai ver a tela carregar e falhar. O que isto evita é oferecer o
 * que não funciona.
 */
export function LayoutDeCadastros() {
  const { temPermissao } = useSessao();

  const abas = [
    { para: 'areas', rotulo: 'Áreas', permissao: 'area.gerenciar' },
    { para: 'clientes', rotulo: 'Clientes', permissao: 'cliente.gerenciar' },
    { para: 'usuarios', rotulo: 'Usuários', permissao: 'usuario.gerenciar' },
  ].filter((aba) => temPermissao(aba.permissao));

  return (
    <div className={estilos.area}>
      <div>
        <h1 className={estilos.titulo}>Cadastros</h1>
        <p className={estilos.apoio}>
          O que as ações usam: áreas para direcionar, clientes para vincular e usuários para
          acessar.
        </p>
      </div>

      {abas.length === 0 ? (
        <p className={estilos.negado} role="alert">
          Você não tem permissão para os cadastros. Eles são de administrador.
        </p>
      ) : (
        <>
          <nav className={estilos.abas} aria-label="Cadastros">
            {abas.map((aba) => (
              <NavLink
                key={aba.para}
                to={aba.para}
                className={({ isActive }) =>
                  isActive ? `${estilos.aba} ${estilos.abaAtiva}` : estilos.aba
                }
              >
                {aba.rotulo}
              </NavLink>
            ))}
          </nav>

          <Outlet />
        </>
      )}
    </div>
  );
}
